/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import styles from './buttonStyles';

interface PropTypes {
  className?: string;
  vendor: 'apple' | 'google';
  id?: string;
}

type HtmlButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const FinancingWalletButton = React.forwardRef<
  HTMLButtonElement,
  PropTypes & HtmlButtonProps
>(({ className, vendor, ...buttonProps }, ref) => {
  return (
    <div css={styles.container} className={className}>
      {vendor === 'apple' ? (
        <button
          ref={ref}
          css={styles.button}
          aria-label="Financing Apple Wallet button"
          type="button"
          {...buttonProps}
        >
          <img
            src={
              'https://id-idss.s3.amazonaws.com/assets/add_to_apple_wallet.png'
            }
            css={styles.img}
            alt="Financing Apple Wallet"
          />
        </button>
      ) : (
        <button
          ref={ref}
          css={styles.button}
          type="button"
          aria-label="Financing Google Wallet button"
          {...buttonProps}
        >
          <img
            src={`https://id-idss.s3.amazonaws.com/assets/add_to_google_pay.png`}
            css={styles.img}
            alt="Financing Google Wallet"
          />
        </button>
      )}
    </div>
  );
});

export default FinancingWalletButton;
